import { styled } from "styled-components";
import tw from "twin.macro";

export const Button = styled.button`
    text-decoration: none;
    border:none;
    padding: 5px 10px;
    color:#002d5e;
    font-weight:bold;
    cursor: pointer;
  ${tw`
    
  `}

  
`;